<div class="container">

 <ng-container *ngIf="!isSubmitted"> 
<div class="card-body">
  <a
    *ngIf="form.data?.buttons?.['new']"
    class="btn btn-outline-secondary btn-sm radius-30 mb-2"
    title="Add New"
    (click)="fieldButtonSubmit('new')"
  >
    <i class="fa fa-plus"></i> New
  </a>

  <p *ngIf="entryform['error'] == false && entryform['message']">
    <app-ncs-alert
      [message]="entryform['message']"
      type="success"
      showAlert="true"
    />
  </p>
  <p *ngIf="entryform['error'] == true && entryform['message']">
    <app-ncs-alert
      [message]="entryform['message']"
      type="danger"
      showAlert="true"
    />
   
  </p>

  <ng-container *ngFor="let uni of usecaseSchema.unique">
    <app-ncs-alert
      *ngIf="isArray(uni) && getInputError(uni.join('_')) !== ''"
      [message]="getInputError(uni.join('_'))"
      showAlert="true"
      type="danger"
    />
  </ng-container>

  <ng-container *ngFor="let group of form.data['groupLabels']; let i = index">
    <ng-container *ngIf="checkTime(group)">
      <ng-container *ngIf="getGroupsField(group.label).length > 0">
        <fieldset class="border border-secondary rounded p-3 mb-2">
          <legend class="float-none w-auto px-2 text-secondary fs-6">
            {{ group.label }}
          </legend>

          <div class="row">
            <ng-container
              *ngFor="let field of getGroupsField(group.label); let i = index"
            >
              <ng-container *ngIf="getAttributeById(field.id) as e">
                <ng-container
                  *ngIf="e['type'] == 'textarea' && evaluateCondition(field)"
                >
                  <div
                    class="col-{{
                      getDefaultColums(form.data.columns, field)
                    }} "
                  >
                    <label
                      for="title"
                      class="form-label"
                      *ngIf="
                        e['type'] !== 'file' &&
                        e['type'] !== 'doc' &&
                        e['type'] !== 'tags' &&
                        e['type'] !== 'combobox'
                      "
                    >
                      {{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <div class="d-flex align-items-center mb-2">
                      <textarea
                        class="form-control"
                        [rows]="field['rows']"
                        cols="{{ field['cols'] }}"
                        class="form-control"
                        [(ngModel)]="entryform.data[e.code]"
                        name="{{ e.code }}"
                        placeholder="{{ getFilterLable(e.label) }}"
                        [readonly]="
                          e['readOnly'] ||
                          (e.allowChangeAfterInitial == 1 &&
                            entryform.data['id'] > 0)
                        "
                      >
                      </textarea>
                    </div>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="e['type'] !== 'textarea' && evaluateCondition(field)"
                >
                  <div class="col-{{ getColums(form.data.columns, field) }}">
                    <label
                      for="title"
                      class="form-label"
                      *ngIf="
                        e['type'] !== 'file' &&
                        e['type'] !== 'doc' &&
                        e['type'] !== 'expression' &&
                        e['type'] !== 'tags' &&
                        e['type'] !== 'location' &&
                        e['type'] !== 'boolean'
                      "
                    >
                      {{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>
                    <label
                      for="title"
                      class="form-label"
                      *ngIf="
                       
                        e['type'] === 'expression' &&
                        e['type'] !== 'location'
                      "
                    >
                      {{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <label
                      for="title"
                      class="form-label"
                      *ngIf="e['type'] === 'file'"
                      >{{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <label
                      for="title"
                      class="form-label"
                      *ngIf="e['type'] === 'doc'"
                      >{{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <label class="form-label" *ngIf="e['type'] === 'location'">
                      {{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <label
                      for="title"
                      class="form-label"
                      *ngIf="e['type'] === 'boolean'"
                    >
                      {{ getFilterLable(e.label) }}
                      <span *ngIf="e['required'] == 1">*</span>
                      <span ncsTooltip [title]="getDescription(e)">
                        <i
                          class="bi bi-info-circle fs-6 ms-2 text-secondary"
                        ></i>
                      </span>
                    </label>

                    <div
                      *ngIf="
                        e['refKey'] != 1 &&
                        e['type'] !== 'list' &&
                        e['type'] !== 'file' &&
                        e['type'] !== 'map' &&
                        e['type'] !== 'doc' &&
                        e['type'] !== 'expression' &&
                        e['type'] !== 'tags' &&
                        e['type'] !== 'combobox' &&
                        e['type'] !== 'location' &&
                        e['type'] !== 'boolean'
                      "
                      class="mb-2"
                    >
                      <div
                        class="d-flex align-items-center"
                        *ngIf="evaluateCondition(field)"
                      >
                        <input
                          required="{{ e['required'] == 1 }}"
                          [type]="getInputType(e.type)"
                          (change)="enforceMaxDate($event, e.code, e.type)"
                          [(ngModel)]="entryform.data[e.code]"
                          class="form-control form-control-sm"
                          id="{{ e.code }}"
                          [readonly]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                          name="{{ e.code }}"
                          (change)="
                            checkRuleExecute(e.code);
                            onDateChange($event, e.code, getInputType(e.type))
                          "
                          [min]="e.type === 'date' ? e.minDate : null"
                          [max]="e.type === 'date' ? e.maxDate : null"
                          placeholder="{{ getFilterLable(e.label) }}"
                          (input)="
                            restrictDecimalPlaces($event, e, e?.placeValue)
                          "
                        />
                      </div>
                    </div>

                    <!-- Location Field Block -->
                    <div *ngIf="e['type'] === 'location'" class="mb-3">
                      <div class="d-flex align-items-center">
                        <!-- Latitude -->
                        <ng-container
                          *ngIf="
                            entryform.data[e.code]?.lat != null &&
                            entryform.data[e.code]?.lng != null
                          "
                        >
                          <input
                            type="number"
                            readonly
                            class="form-control form-control-sm me-2"
                            placeholder="Latitude"
                            [(ngModel)]="entryform.data[e.code].lat"
                            name="{{ e.code + '_lat' }}"
                          />

                          <input
                            type="number"
                            readonly
                            class="form-control form-control-sm me-2"
                            placeholder="Longitude"
                            [(ngModel)]="entryform.data[e.code].lng"
                            name="{{ e.code + '_lng' }}"
                          />
                        </ng-container>

                        <!-- Show this block if lat/lng is null -->
                        <ng-template #emptyInputs>
                          <input
                            type="text"
                            readonly
                            class="form-control form-control-sm me-2"
                            value="No location set"
                            name="{{ e.code + '_lat_placeholder' }}"
                          />

                          <input
                            type="text"
                            readonly
                            class="form-control form-control-sm me-2"
                            value="No location set"
                            name="{{ e.code + '_lng_placeholder' }}"
                          />
                        </ng-template>

                        <!-- Set current location -->
                        <button
                          title="location"
                          type="button"
                          class="btn btn-sm btn-primary btn-outline-secondary p-0 me-1"
                          (click)="setCurrentLocation(e.code)"
                        >
                          <i class="bi bi-geo-alt-fill"></i>
                        </button>

                        <!-- View on map -->
                        <button
                          title="View on map"
                          type="button"
                          class="btn btn-sm btn-primary btn-outline-secondary p-0 me-1"
                          (click)="viewOnMap(e.code)"
                        >
                          <i class="bi bi-eye"></i>
                        </button>

                        <!-- Clear location -->
                        <button
                          title="Clear location"
                          type="button"
                          class="btn btn-sm btn-danger btn-outline-secondary p-0"
                          (click)="clearLocation(e.code)"
                        >
                          <i class="bi bi-eraser"></i>
                        </button>
                      </div>
                    </div>

                    <div
                      *ngIf="e['type'] === 'expression'"
                      class="mb-2"
                    >
                      <div
                        class="d-flex align-items-center"
                        *ngIf="evaluateCondition(field)"
                      >
                        <input
                          required="{{ e['required'] == 1 }}"
                          disabled
                          [(ngModel)]="entryform.data[e.code]"
                          class="form-control form-control-sm"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                          placeholder="{{ getFilterLable(e.label) }}"
                          [readonly]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                        />
                      </div>
                    </div>

                    <div *ngIf="e['type'] === 'boolean'" class="mb-2">
                      <div
                        class="d-flex align-items-center"
                        *ngIf="evaluateCondition(field)"
                      >
                        <select
                          [(ngModel)]="entryform.data[e.code]"
                          class="form-control form-control-sm"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                        >
                          <option [ngValue]="undefined" disabled selected>
                            --Select--
                          </option>
                          <option [ngValue]="1">True</option>
                          <option [ngValue]="0">False</option>
                        </select>
                      </div>
                    </div>

                    <!-- Preload DropDown List  -->
                    <div *ngIf="e['refKey'] == 1" class="mb-2">
                      <div class="d-flex align-items-center">
                        <select
                          required="{{ e['required'] == 1 }}"
                          [(ngModel)]="entryform.data[e.code]"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                          [ngClass]="{
                            'placeholder-grey':
                              entryform.data[e.code] === undefined ||
                              entryform.data[e.code] === 'undefined'
                          }"
                          (change)="
                            onChange(e, $event); checkRuleExecute(e.code)
                          "
                          class="form-select form-select-sm"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                        >
                          <option [value]="undefined">
                            --Select-- {{ e.label }}
                          </option>
                          <option
                            *ngFor="let c of form.preload?.[e['primaryUsecase']] || [] "
                            value="{{ c['id'] }}"
                          >
                            {{ c["_val"] }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- DropDown List  -->
                    <div *ngIf="e['type'] === 'list'" class="mb-2 w-100">
                      <div class="d-flex align-items-center w-100">
                        <!-- MULTIPLE SELECT -->
                        <div
                          *ngIf="e['multipleSelect'] == 1"
                          class="position-relative w-100"
                        >
                          <!-- Dropdown container with Bootstrap 5.3 classes -->
                          <div
                            class="form-select form-select-sm d-flex align-items-center justify-content-between"
                            (click)="toggleDropdown(e)"
                            [class.disabled]="
                              e['readOnly'] ||
                              (e.allowChangeAfterInitial == 1 &&
                                entryform.data['id'] > 0)
                            "
                          >
                            <span
                              class="text-truncate"
                              [ngClass]="{
                                'placeholder-grey': !getSelectedText(e)
                              }"
                            >
                              {{
                                getSelectedText(e) || "--Select-- " + e.label
                              }}
                            </span>
                          </div>

                          <!-- Dropdown options with Bootstrap classes -->
                          <div
                            *ngIf="e.isDropdownOpen"
                            class="dropdown-menu show w-100 mt-1 shadow overflow-auto"
                            style="max-height: 200px"
                          >
                            <div
                              *ngFor="let option of e['values']"
                              class="dropdown-item p-1"
                            >
                              <label
                                class="d-flex align-items-center m-0"
                                (click)="$event.stopPropagation()"
                              >
                                <input
                                  type="checkbox"
                                  class="form-check-input me-2"
                                  [checked]="
                                    entryform.data[e.code]?.includes(option)
                                  "
                                  (change)="onCheckboxChange(e, option, $event)"
                                />
                                <div class="dropdown-item" [ngClass]="{'hover-primary': isHovered}" [title]="option">
                               <option>{{ option | truncate:getTruncateLimit(form.data.columns) }}</option>
                                </div>
                              </label>
                            </div>
                          </div>
                        </div>

                        <!-- SINGLE SELECT -->
                        <select
                          *ngIf="e['multipleSelect'] != 1"
                          required="{{ e['required'] == 1 }}"
                          [(ngModel)]="entryform.data[e.code]"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                          [ngClass]="{
                            'placeholder-grey':
                              entryform.data[e.code] === undefined ||
                              entryform.data[e.code] === 'undefined'
                          }"
                          (change)="onChange(e, $event)"
                          class="form-select form-select-sm"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                        >
                          <option [disabled]="e['required'] == 1" value="undefined">
                            --Select-- {{ e.label }}
                          </option>
                          <option *ngFor="let c of e['values']" [value]="c" [title]="c">
                             {{ c | truncate:getTruncateLimit(form.data.columns) }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Image File Input (Dynamic) -->
                                                <div *ngIf="e['type'] === 'file'"
                                                    class="mb-2">
                      <div class="d-flex align-items-center">
                                                        <input class="form-control" id="entryform.data[e.code]" #file
                                                            type="file" accept="image/*" name="entryform.data[e.code]"
                          (click)="onFileChooseClicked(file, e.code)"
                                                            (change)="file.files && onImageFileChanged($event, e, entryform.data[e.code])" />
                      </div>

                      <!-- Show error only for the specific field -->
                      <div *ngIf="fileErrors[e.code]" class="text-danger">
                                                        Invalid file type. Please upload only JPEG, JPG, PNG, or GIF
                                                        files.
                      </div>
                      <div *ngIf="imageSizes[e.code]" class="text-danger">
                                                        Max File Limit is {{e.size || 1 }} MB.
                      </div>
                    </div>

                    <!-- Image Preview -->
                    <div class="mb-4" *ngIf="e['type'] === 'file'">
                      <div *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
                        <a
                          href="{{ getDoc(entryform.data[e.code]) }}"
                          target="_blank"
                        >
                          <img
                            [src]="
                              imagePreviews[e.code]
                                ? imagePreviews[e.code]
                                : getDocThumbnail(entryform.data[e.code])
                            "
                            alt="Image Preview"
                            class="img-thumbnail"
                            style="width: 200px; height: 150px"
                          />
                        </a>
                      </div>
                    </div>

                    <!-- Doc File  -->
                    <div *ngIf="e['type'] === 'doc'" class="mb-2">
                      <div class="d-flex align-items-center">
                                            <input class="form-control" id="entryform.data[e.code]" #filedoc type="file" name="entryform.data[e.code]"
                                                (change)="filedoc.files && onFileChanged($event,e,entryform.data[e.code])" />
                                        </div>

                                        <div *ngIf="docSizes[e.code]" class="text-danger">
                                            File size is greater than {{ e.size || 1 }} MB.
                                        </div>
                                        
                                        <div *ngIf="docFileErrors[e.code]" class="text-danger">
                                            Invalid file type. Only PDF, DOC, EXCEL, DOCX allowed.
                      </div>
                    </div>

                    <!--Image Preview Doc Preview -->
                    <div class="mb-4" *ngIf="e['type'] === 'doc'">
                      <a
                        href="{{ getDoc(entryform.data[e.code]) }}"
                        target="_blank"
                      >
                        <img
                          [src]="
                            imagePreview == null
                              ? getDocThumbnail(entryform.data[e.code])
                              : imagePreview
                          "
                          alt="Image Preview"
                          class="img-thumbnail"
                          style="width: 200px; height: 150px"
                        />
                      </a>
                    </div>

                    <!-- Static DropDown List  -->
                    <div *ngIf="e['type'] === 'map'" class="mb-2">
                      <div class="d-flex align-items-center">
                        <select
                          required="{{ e['required'] == 1 }}"
                          [(ngModel)]="entryform.data[e.code]"
                          [ngClass]="{
                            'placeholder-grey':
                              entryform.data[e.code] === undefined ||
                              entryform.data[e.code] === 'undefined'
                          }"
                          [disabled]="
                            e['readOnly'] ||
                            (e.allowChangeAfterInitial == 1 &&
                              entryform.data['id'] > 0)
                          "
                          (change)="onChange(e, $event)"
                          class="form-select form-select-sm"
                          id="{{ e.code }}"
                          name="{{ e.code }}"
                        >
                          <option [disabled]="e['required'] == 1" [value]="undefined">
                            --Select-- {{ e.code }}
                          </option>
                          <option
                            *ngFor="let c of e['values']"
                            value="{{ c.key }} - {{ c.value }}"
                          >
                            {{ c.key }} - {{ c.value }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <app-combobox
                      *ngIf="e['type'] === 'combobox'"
                      [e]="e"
                      [entryData]="entryform.data[e.code]"
                      (valueChange)="entryform.data[e.code] = $event"
                      [readonly]="
                        e['readOnly'] ||
                        (e.allowChangeAfterInitial == 1 &&
                          entryform.data['id'] > 0)
                      "
                      [checkExpression]="checkExpression"
                      [id]="entryform.data['id']"
                    >
                    </app-combobox>

                    <div class="form-text text-danger mb-2">
                      {{ getInputError(e.code) }}
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </fieldset>
      </ng-container>
    </ng-container>
  </ng-container>
  <div  class="row">
    <ng-container *ngIf="form?.data?.fields">
    <ng-container *ngFor="let field of getFieldNotIngroup(); let i = index">
      <ng-container *ngIf="getAttributeById(field.id) as e">
        <ng-container
          *ngIf="e['type'] == 'textarea' && evaluateCondition(field)"
        >
          <div class="col-{{ getDefaultColums(form.data.columns, field) }} ">
            <label
              for="title"
              class="form-label"
              *ngIf="
                e['type'] !== 'file' &&
                e['type'] !== 'doc' &&
                e['type'] !== 'tags' &&
                e['type'] !== 'combobox'
              "
            >
              {{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <div class="d-flex align-items-center mb-2">
              <textarea
                class="form-control"
                [rows]="field['rows']"
                cols="{{ field['cols'] }}"
                class="form-control"
                [(ngModel)]="entryform.data[e.code]"
                name="{{ e.code }}"
                placeholder="{{ getFilterLable(e.label) }}"
                [readonly]="
                  e['readOnly'] ||
                  (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                "
              >
              </textarea>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="e['type'] !== 'textarea' && evaluateCondition(field)"
        >
          <div class="col-{{ getColums(form.data.columns, field) }}">
            <label
              for="title"
              class="form-label"
              *ngIf="
                e['type'] !== 'file' &&
                e['type'] !== 'doc' &&
                e['type'] !== 'expression' &&
                e['type'] !== 'tags' &&
                e['type'] !== 'location' &&
                e['type'] !== 'boolean'
              "
            >
              {{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>
            <label
              for="title"
              class="form-label"
              *ngIf="
                
                
                e['type'] === 'expression' &&
                e['type'] !== 'location'
              "
            >
              {{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <label for="title" class="form-label" *ngIf="e['type'] === 'file'"
              >{{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <label for="title" class="form-label" *ngIf="e['type'] === 'doc'"
              >{{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <label class="form-label" *ngIf="e['type'] === 'location'">
              {{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <label
              for="title"
              class="form-label"
              *ngIf="e['type'] === 'boolean'"
            >
              {{ getFilterLable(e.label) }}
              <span *ngIf="e['required'] == 1">*</span>
              <span ncsTooltip [title]="getDescription(e)">
                <i class="bi bi-info-circle fs-6 ms-2 text-secondary"></i>
              </span>
            </label>

            <div
              *ngIf="
                e['refKey'] != 1 &&
                e['type'] !== 'list' &&
                e['type'] !== 'file' &&
                e['type'] !== 'map' &&
                e['type'] !== 'doc' &&
                e['type'] !== 'expression' &&
                e['type'] !== 'tags' &&
                e['type'] !== 'combobox' &&
                e['type'] !== 'location' &&
                e['type'] !== 'boolean'
              "
              class="mb-2"
            >
              <div
                class="d-flex align-items-center"
                *ngIf="evaluateCondition(field)"
              >
                <input
                  required="{{ e['required'] == 1 }}"
                  [type]="getInputType(e.type)"
                  (change)="enforceMaxDate($event, e.code,e.type)"
                  [(ngModel)]="entryform.data[e.code]"
                  class="form-control form-control-sm"
                  id="{{ e.code }}"
                  [readonly]="
                    e['readOnly'] ||
                    (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                  "
                  name="{{ e.code }}"
                  (change)="
                    checkRuleExecute(e.code);
                    onDateChange($event, e.code, getInputType(e.type))
                  "
                  [min]="e.type === 'date' ? e.minDate : null"
                  [max]="e.type === 'date' ? e.maxDate : null"
                  placeholder="{{ getFilterLable(e.label) }}"
                  (input)="restrictDecimalPlaces($event, e, e?.placeValue); clearInputError(e.code)"
                />
              </div>
            </div>
            <!-- Location Field Block -->
            <div *ngIf="e['type'] === 'location'" class="mb-3">
              <div class="d-flex align-items-center">
                <!-- Latitude -->
                <ng-container
                  *ngIf="
                    entryform.data[e.code]?.lat != null &&
                    entryform.data[e.code]?.lng != null
                  "
                >
                  <input
                    type="number"
                    readonly
                    class="form-control form-control-sm me-2"
                    placeholder="Latitude"
                    [(ngModel)]="entryform.data[e.code].lat"
                    name="{{ e.code + '_lat' }}"
                  />

                  <input
                    type="number"
                    readonly
                    class="form-control form-control-sm me-2"
                    placeholder="Longitude"
                    [(ngModel)]="entryform.data[e.code].lng"
                    name="{{ e.code + '_lng' }}"
                  />
                </ng-container>

                <!-- Show this block if lat/lng is null -->
                <ng-template #emptyInputs>
                  <input
                    type="text"
                    readonly
                    class="form-control form-control-sm me-2"
                    value="No location set"
                    name="{{ e.code + '_lat_placeholder' }}"
                  />

                  <input
                    type="text"
                    readonly
                    class="form-control form-control-sm me-2"
                    value="No location set"
                    name="{{ e.code + '_lng_placeholder' }}"
                  />
                </ng-template>

                <!-- Set current location -->
                <button
                  title="location"
                  type="button"
                  class="btn btn-sm btn-primary btn-outline-secondary p-0 me-1"
                  (click)="setCurrentLocation(e.code)"
                >
                  <i class="bi bi-geo-alt-fill"></i>
                </button>

                <!-- View on map -->
                <button
                  title="View on map"
                  type="button"
                  class="btn btn-sm btn-primary btn-outline-secondary p-0 me-1"
                  (click)="viewOnMap(e.code)"
                >
                  <i class="bi bi-eye"></i>
                </button>

                <!-- Clear location -->
                <button
                  title="Clear location"
                  type="button"
                  class="btn btn-sm btn-danger btn-outline-secondary p-0"
                  (click)="clearLocation(e.code)"
                >
                  <i class="bi bi-eraser"></i>
                </button>
              </div>
            </div>

            <div
              *ngIf="e['type'] === 'expression' 
              "
              class="mb-2"
            >
              <div
                class="d-flex align-items-center"
                *ngIf="evaluateCondition(field)"
              >
                <input
                  required="{{ e['required'] == 1 }}"
                  disabled
                  [(ngModel)]="entryform.data[e.code]"
                  class="form-control form-control-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                  placeholder="{{ getFilterLable(e.label) }}"
                  [readonly]="
                    e['readOnly'] ||
                    (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                  "
                />
              </div>
            </div>

            <div *ngIf="e['type'] === 'boolean'" class="mb-2">
              <div
                class="d-flex align-items-center"
                *ngIf="evaluateCondition(field)"
              >
                <select
                  [(ngModel)]="entryform.data[e.code]"
                  class="form-control form-control-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                >
                  <option [ngValue]="undefined" disabled selected>
                    --Select--
                  </option>
                  <option [ngValue]="1">True</option>
                  <option [ngValue]="0">False</option>
                </select>
              </div>
            </div>

            <!-- Preload DropDown List  -->
            <div *ngIf="e['refKey'] == 1" class="mb-2">
              <div class="d-flex align-items-center">
                <select
                  required="{{ e['required'] == 1 }}"
                  [(ngModel)]="entryform.data[e.code]"
                  [disabled]="
                    e['readOnly'] ||
                    (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                  "
                  [ngClass]="{
                    'placeholder-grey':
                      entryform.data[e.code] === undefined ||
                      entryform.data[e.code] === 'undefined'
                  }"
                  (change)="onChange(e, $event); checkRuleExecute(e.code)"
                  class="form-select form-select-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                >
                  <option [value]="undefined">--Select-- {{ e.label }}</option>
                  <option
                    *ngFor="let c of form.preload?.[e['primaryUsecase']] || [] "
                    value="{{ c['id'] }}"
                  >
                    {{ c["_val"] }}
                  </option>
                </select>
              </div>
            </div>

            <!-- DropDown List  -->
            <div *ngIf="e['type'] === 'list'" class="mb-2 w-100">
              <div class="d-flex align-items-center w-100">
                <!-- MULTIPLE SELECT -->
                <div
                  *ngIf="e['multipleSelect'] == 1"
                  class="position-relative w-100"
                >
                  <!-- Dropdown container with Bootstrap 5.3 classes -->
                  <div
                    class="form-select form-select-sm d-flex align-items-center justify-content-between"
                    (click)="toggleDropdown(e)"
                    [class.disabled]="
                      e['readOnly'] ||
                      (e.allowChangeAfterInitial == 1 &&
                        entryform.data['id'] > 0)
                    "
                  >
                    <span
                      class="text-truncate"
                      [ngClass]="{
                        'placeholder-grey': !getSelectedText(e)
                      }"
                    >
                      {{ getSelectedText(e) || "--Select-- " + e.label }}
                    </span>
                  </div>

                  <!-- Dropdown options with Bootstrap classes -->
                  <div
                    *ngIf="e.isDropdownOpen"
                    class="dropdown-menu show w-100 mt-1 shadow overflow-auto"
                    style="max-height: 200px"
                  >
                    <div
                      *ngFor="let option of e['values']"
                      class="dropdown-item p-1"
                    >
                      <label
                        class="d-flex align-items-center m-0"
                        (click)="$event.stopPropagation()"
                      >
                        <input
                          type="checkbox"
                          class="form-check-input me-2"
                          [checked]="entryform.data[e.code]?.includes(option)"
                          (change)="onCheckboxChange(e, option, $event)"
                        />
                         <div class="dropdown-item" [ngClass]="{'hover-primary': isHovered}" [title]="option">
                               <option>{{ option | truncate:getTruncateLimit(form.data.columns) }}</option>
                        </div>
                      </label>
                    </div>
                  </div>
                </div>

                <!-- SINGLE SELECT -->
                <select
                  *ngIf="e['multipleSelect'] != 1"
                  required="{{ e['required'] == 1 }}"
                  [(ngModel)]="entryform.data[e.code]"
                  [disabled]="
                    e['readOnly'] ||
                    (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                  "
                  [ngClass]="{
                    'placeholder-grey':
                      entryform.data[e.code] === undefined ||
                      entryform.data[e.code] === 'undefined'
                  }"
                  (change)="onChange(e, $event)"
                  class="form-select form-select-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                >
                  <option [disabled]="e['required'] == 1" value="undefined">--Select-- {{ e.label }}</option>
                   <option *ngFor="let c of e['values']" [value]="c" [title]="c">
                     {{ c | truncate:getTruncateLimit(form.data.columns) }}
                  </option>
                </select>
              </div>
            </div>

            <!-- Image File Input (Dynamic) -->
                                                <div *ngIf="e['type'] === 'file'"   class="mb-2">
                                                   <div class="d-flex align-items-center">
                                                        <input class="form-control" id="entryform.data[e.code]" #file
                                                            type="file" accept="image/*" name="entryform.data[e.code]"
                                                            (click)="onFileChooseClicked(file, e.code)"
                                                            (change)="file.files && onImageFileChanged($event, e, entryform.data[e.code])" />
                                                  </div>

              <!-- Show error only for the specific field -->
              <div *ngIf="fileErrors[e.code]" class="text-danger">
                Invalid file type. Please upload only JPEG, JPG, PNG, or GIF
                files.
              </div>
              <div *ngIf="imageSizes[e.code]" class="text-danger">
                                                        Max File Limit is {{e.size || 1 }} MB.
              </div>
            </div>

            <!-- Image Preview -->
            <div class="mb-4" *ngIf="e['type'] === 'file'">
              <div *ngIf="!fileErrors[e.code] && !imageSizes[e.code]">
                        <a
                          href="{{ getDoc(entryform.data[e.code]) }}"
                          target="_blank"
                        >
                  <img
                    [src]="
                      imagePreviews[e.code]
                        ? imagePreviews[e.code]
                        : getDocThumbnail(entryform.data[e.code])
                    "
                    alt="Image Preview"
                    class="img-thumbnail"
                    style="width: 200px; height: 150px"
                  />
                </a>
              </div>
            </div>

            <!-- Doc File  -->
            <div *ngIf="e['type'] === 'doc'" class="mb-2">
              <div class="d-flex align-items-center">
                                            <input class="form-control" id="entryform.data[e.code]" #filedoc type="file" name="entryform.data[e.code]"
                                                (change)="filedoc.files && onFileChanged($event,e,entryform.data[e.code])" />
                                        </div>

                                        <div *ngIf="docSizes[e.code]" class="text-danger">
                                            File size is greater than {{ e.size || 1 }} MB.
                                        </div>
                                        
                                        <div *ngIf="docFileErrors[e.code]" class="text-danger">
                                            Invalid file type. Only PDF, DOC, EXCEL , DOCX allowed.
              </div>
            </div>

            <!--Image Preview Doc Preview -->
            <div class="mb-4" *ngIf="e['type'] === 'doc'">
                      <a
                        href="{{ getDoc(entryform.data[e.code]) }}"
                        target="_blank"
                      >
                <img
                  [src]="
                    imagePreview == null
                      ? getDocThumbnail(entryform.data[e.code])
                      : imagePreview
                  "
                  alt="Image Preview"
                  class="img-thumbnail"
                  style="width: 200px; height: 150px"
                />
              </a>
            </div>

            <!-- Static DropDown List  -->
            <div *ngIf="e['type'] === 'map'" class="mb-2">
              <div class="d-flex align-items-center">
                <select
                  required="{{ e['required'] == 1 }}"
                  [(ngModel)]="entryform.data[e.code]"
                  [ngClass]="{
                    'placeholder-grey':
                      entryform.data[e.code] === undefined ||
                      entryform.data[e.code] === 'undefined'
                  }"
                  [disabled]="
                    e['readOnly'] ||
                    (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
                  "
                  (change)="onChange(e, $event)"
                  class="form-select form-select-sm"
                  id="{{ e.code }}"
                  name="{{ e.code }}"
                >
                  <option [disabled]="e['required'] == 1" [value]="undefined">--Select-- {{ e.code }}</option>
                  <option
                    *ngFor="let c of e['values']"
                    value="{{ c.key }} - {{ c.value }}"
                  >
                    {{ c.key }} - {{ c.value }}
                  </option>
                </select>
              </div>
            </div>
            <app-combobox
              *ngIf="e['type'] === 'combobox'"
              [e]="e"
              [entryData]="entryform.data[e.code]"
              (valueChange)="entryform.data[e.code] = $event"
              [readonly]="
                e['readOnly'] ||
                (e.allowChangeAfterInitial == 1 && entryform.data['id'] > 0)
              "
              [checkExpression]="checkExpression"
              [id]="entryform.data['id']"
            >
            </app-combobox>
            <div class="form-text text-danger mb-2">
              {{ getInputError(e.code) }}
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
     </ng-container>
   

    <div
      *ngFor="let field of form.data['fields']; let i = index"
      class="col-{{ getColums(form.data.columns, field) }}  {{
        getRows(field)
      }}"
    ></div>
  </div>

  <div *ngIf="form.data['id'] == 0">not field for edit</div>

  <!-- Card Footer with Button Group -->
  <!-- <div class="text-start" *ngIf="form.data['id'] > 0">
    <div class="btn-group" *ngIf="form.data.readOnly != 'true'">
      <button
        *ngFor="let btn of form.data.buttons"
        type="button"
        class="btn btn-sm btn-outline-primary ms-2"
        (click)="fieldButtonSubmit(btn['name'])"
      >
        <i [class]="getButtonIcon(btn['name'])"></i>
        {{ getButtonLabel(btn["name"]) }}
      </button>
    </div>
  </div> -->


  <div class="text-start mt-4">
  <div class="btn-group" *ngIf="form.data.readOnly != 'true'">

    <button
      type="button"
      class="btn btn-sm btn-outline-primary ms-2"
      (click)="onSave()"
      [disabled]="isSubmitted"
    >
     <i class="fa-save fas"></i>
      Save
    </button>
    
    <button
      type="button"
      class="btn btn-sm btn-outline-primary ms-2"
      (click)="onCancel()"
    >
      <i class="fa-times fas"></i>
      Cancel
    </button>
  </div>
</div>
</div>
</ng-container>

<ng-container *ngIf="isSubmitted">
    <div class="thank-you-message-box card">
      <div class="card-body">
        <h2 class="card-title text-success">
          <i class="bi bi-check-circle-fill me-2"></i> Thank You!
        </h2>
        <p class="card-text mb-1">
          Your response has been recorded.
        </p>
        
        <button class="btn btn-outline-primary btn-sm mt-3" (click)="resetFormAndRedirect()">
          Submit another response
        </button>
  </div>
</div>
  </ng-container>

</div>